import { BaseQueryApi, FetchArgs, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { message } from 'antd';
// eslint-disable-next-line import/no-cycle
import { RootState } from '../redux/store';
import { setLogout } from '../redux/slice';

const baseQuery = fetchBaseQuery({
	baseUrl: `${process.env.REACT_APP_API_URL}/`,
	prepareHeaders: (headers, { getState }) => {
		const token = (getState() as RootState).admin?.token;
		if (token) {
			headers.set('Authorization', `Bearer ${token}`);
			headers.set('Accept', 'application/json');
			headers.set('Content-Type', 'application/json');
			headers.set('ngrok-skip-browser-warning', 'true');
		}
		return headers;
	},
});

export const baseQueryWithInterceptor = async (
	args: unknown,
	api: BaseQueryApi,
	extraOptions: { single?: AbortSignal },
) => {
	const result = await baseQuery(args as FetchArgs, api, extraOptions);
	if (result?.error?.status === 401) {
		const body = result.error.data as { message?: string } | undefined;
		message.error(body?.message ?? 'Your session has expired. Please sign in again.');
		api.dispatch(setLogout());
		window.location.assign('/login');
	}
	return result;
};

const adminApi = createApi({
	reducerPath: 'adminApi',
	keepUnusedDataFor: 60,
	baseQuery: baseQueryWithInterceptor,
	endpoints: () => ({}),
});

export default adminApi;
